import { uid } from 'uid'

export default {
  checkout(order) {
    if (!window.uetq) return

    try {
      window.uetq.push('event', 'purchase', {
        event_category: 'ecommerce',
        event_label: 'purchase',
        revenue_value: order.value,
        currency: order.currency,
        event_id: uid(32),
      })
    } catch (error) {
      console.error('[Bing UET] Checkout tracking failed:', error)
    }
  },

  addToCart(product) {
    if (!window.uetq) return

    try {
      window.uetq.push('event', 'add_to_cart', {
        event_category: 'ecommerce',
        event_label: 'add_to_cart',
        revenue_value: product.value,
        currency: product.currency,
        event_id: uid(32),
      })
    } catch (error) {
      console.error('[Bing UET] Add to cart tracking failed:', error)
    }
  },

  viewContent(product) {
    if (!window.uetq) return

    try {
      window.uetq.push('event', 'view_item', {
        event_category: 'ecommerce',
        event_label: 'view_item',
        revenue_value: product.value,
        currency: product.currency,
        event_id: uid(32),
      })
    } catch (error) {
      console.error('[Bing UET] View content tracking failed:', error)
    }
  },

  pageVisit() {
    if (!window.uetq) return

    try {
      window.uetq.push('event', 'page_view', {
        event_category: 'page',
        event_label: 'page_view',
        event_id: uid(32),
      })
    } catch (error) {
      console.error('[Bing UET] Page view tracking failed:', error)
    }
  },

  conversion(goalId, conversionValue, currency = 'USD') {
    if (!window.uetq) return

    try {
      window.uetq.push('event', goalId, {
        revenue_value: conversionValue,
        currency: currency,
        event_id: uid(32),
      })
    } catch (error) {
      console.error('[Bing UET] Conversion tracking failed:', error)
    }
  },
}
